import React from 'react';

const Motion = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 86.318 81.608"
			className={className}
		>
			<path
				d="m5.83 72.211 10.526-6.076 26.8 15.473 26.8-15.473 10.526 6.076-1.438 2.493h7.275l-3.636-6.3-1.438 2.493-10.526-6.076V33.874l-26.8-15.473v-12.1h2.878l-3.636-6.3-3.638 6.3h2.878v12.1l-26.8 15.473V64.82L5.077 70.896l-1.438-2.493-3.636 6.3h7.275L5.84 72.212Zm13.564-34.83 22.621 13.06v26.12l-22.621-13.06Zm47.521 26.12-22.621 13.06v-26.12l22.621-13.06ZM43.154 48.467 20.53 35.407l22.621-13.06 22.621 13.06Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default Motion;
